import { Outlet, useParams } from 'react-router-dom';
import { Header } from "../Header/Header";
import Footer from "../Footer/Footer";


const Layout = () => {
  const params = useParams();

  const hideLayout = Object.values(params).some((value) =>
    value.toLowerCase().includes("sitemap")
  );

  return (
    <div>
      {!hideLayout && <Header />}
      <main>
        <Outlet />
      </main>
      {!hideLayout && <Footer />}
    </div>
  );
};

export default Layout;
